import { Box } from "@chakra-ui/react";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { gql } from "__generated__/gql";
import SelectedEmail from "components/Shared/SelectedEmail";
import { asyncVoid } from "utils/asyncVoidHandler";
import SelectedEmailActions from "./Actions";

const selectedEmailQuery = gql(/* GraphQL */ `
  query BrandEmailInboxSelectedEmail($id: UUID!) {
    receivedEmailMessage(emailMessageId: $id) {
      emailMessageId
      ...SelectedEmail
      ...BrandSelectedEmailActions
    }
  }
`);

type Props = { emailId: UUID | null | undefined };

export default function BrandEmailInboxSelected({ emailId }: Props) {
  const { data, loading, refetch } = useBrandQuery(selectedEmailQuery, {
    variables: emailId ? { id: emailId } : undefined,
    skip: !emailId,
    returnPartialData: true,
  });

  return (
    <Box p={5}>
      <SelectedEmail
        data={data?.receivedEmailMessage}
        isLoading={loading}
        onRefresh={() => asyncVoid(refetch())}
        actions={<SelectedEmailActions data={data?.receivedEmailMessage} />}
      />
    </Box>
  );
}
